import moment from 'moment';
import React from 'react';
import { Link } from 'react-router';
import { vsprintf } from 'sprintf-js';

class Restriction extends React.Component {
    render () {
        const restriction = this.props.restriction;

        if (!restriction) {
            return;
        }

        var delayed;
        if (restriction.delay_until) {
            delayed = <span><br />Delayed Until {moment(restriction.delay_until).format(_DATE_FORMAT)}</span>
        }

        switch (restriction.type) {
            case 'overlimit':
            case 'overlimit_shaped':
                const word = restriction.type === 'overlimit' ? 'Overlimit' : 'Shaped';
                const period = restriction.period === 'peak' ? 'Peak' : 'Offpeak';

                return <p className="text-orange">{word} {period} until {moment(restriction.expires).format(_DATE_FORMAT)}{delayed}</p>;

            case 'overdue_suspension':
                return <p className="text-red">Suspended Service &mdash; <Link to="payment" className="text-red">Unpaid Invoice {restriction.invoice ? restriction.invoice.number : ''}</Link>{delayed}</p>;

            case 'plan_change':
                if (moment(restriction.delay_until).unix() > moment().unix()) {
                    return <p className="text-red">Scheduled plan change - {restriction.offerName} at {moment(restriction.delay_until).format(_DATE_FORMAT)}</p>
                } else {
                    return <p className="text-red">Plan change - {restriction.offerName} (being processed)</p>
                }
        }

        return null;
    }
}
Restriction.propTypes = {
    restriction: React.PropTypes.object,
};

export default Restriction;



// WEBPACK FOOTER //
// ./app/components/ClientService/Restriction.js